import farmToBusiness1x from './farm-to-business@1x.png';
import farmToBusiness2x from './farm-to-business@2x.png';
import farmToBusiness3x from './farm-to-business@3x.png';

import gyomuJapan1x from './gyomu-japan@1x.png';
import gyomuJapan2x from './gyomu-japan@2x.png';
import gyomuJapan3x from './gyomu-japan@3x.png';

import kamereoDistributor1x from './kamereo-distribution@1x.png';
import kamereoDistributor2x from './kamereo-distribution@2x.png';
import kamereoDistributor3x from './kamereo-distribution@3x.png';

import kamereoLabel1x from './kamereo-label@1x.png';
import kamereoLabel2x from './kamereo-label@2x.png';
import kamereoLabel3x from './kamereo-label@3x.png';

const ProductDetailsBannerImages = {
  farmToBusiness1x: farmToBusiness1x,
  farmToBusiness2x: farmToBusiness2x,
  farmToBusiness3x: farmToBusiness3x,
  gyomuJapan1x: gyomuJapan1x,
  gyomuJapan2x: gyomuJapan2x,
  gyomuJapan3x: gyomuJapan3x,
  kamereoDistributor1x: kamereoDistributor1x,
  kamereoDistributor2x: kamereoDistributor2x,
  kamereoDistributor3x: kamereoDistributor3x,
  kamereoLabel1x: kamereoLabel1x,
  kamereoLabel2x: kamereoLabel2x,
  kamereoLabel3x: kamereoLabel3x,
};

export default ProductDetailsBannerImages;
